import {
  ProductionPlanSupplier,
  ProductionPlanSupplierProvider,
} from "features/production-plan-supplier";

const ProductionPlanSupplierPage = () => (
  <ProductionPlanSupplierProvider>
    <ProductionPlanSupplier />
  </ProductionPlanSupplierProvider>
);
export default ProductionPlanSupplierPage;
